module.exports = "<div>\n  <div class=\"center\">\n    <h2>Elenco teleconsulti</h2>\n  </div>\n\n  <div>\n    <easyui-datagrid #grid [options]=\"dataGridOptions\" id=\"dataGridEl\"></easyui-datagrid>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/appuntamenti-specialistiche/appuntamenti-specialistiche.html
// module id = ./src/app/components/appuntamenti-specialistiche/appuntamenti-specialistiche.html
// module chunks = main